// user.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import * as UserActions from '../actions/user.actions';
import { AppUserState } from '../states/app.state';
import { UAMAuthService } from 'src/app/shared/services/uam-auth.service';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private uamAuthService: UAMAuthService
  ) { }

  loadCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType('[App] Init'),
      map(() => {
        const user = this.uamAuthService.getAuthenticatedUser() as any;
        if (user && user.sub) {
          const currentUser: AppUserState = {
            sub: user.sub,
            name: user.name,
            lastName: user.family_name,
            role: user['custom:emirld_role'],
            email: user.email,
          };
          return UserActions.setCurrentUser({ currentUser });
        } else {
          return UserActions.clearCurrentUser();
        }
      }),
      catchError(() => of(UserActions.clearCurrentUser()))
    )
  );

  setCurrentUser$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActions.setCurrentUser)
      ),
    { dispatch: false }
  );

  clearCurrentUser$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActions.clearCurrentUser),
        // tap(() => {
        //   console.log('User cleared from store');
        // })
      ),
    { dispatch: false }
  );
}
